<template>
  <b-container fluid>
    <b-row>
      <b-col class="col-lg-4" offset="2" style="margin-top: 10px">
        <h2 class="text-left">{{title}}</h2>
        <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
        <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
      </b-col>
      <b-col class="col-lg-4" offset="2">
        <label>Belangrijk! : Wijzigingen worden periodiek verwerkt, en zijn dus niet direct zichtbaar </label>
      </b-col>
    </b-row>
    <b-row style="margin-top: 30px; ">
      <b-col class="col-lg-4" offset="2" style="text-align: center;">
        <label class="labelStyle">
          Download
        </label>
        <img src="../../assets/Download.png" style="width: 7%" />
      </b-col>
      <b-col class="col-lg-4" style="text-align: center;">
        <label class="labelStyle">
          Upload
        </label>
        <img src="../../assets/Upload.png" style="width: 5.5%" />
      </b-col>
    </b-row>
    <b-row class="border">
      <b-col class="col-lg-1" offset="1">
        <label>Artikel vertalingen en categorieën</label>
      </b-col>
      <b-col class="col-lg-4" style="text-align: center;">
        <b-button class="btn buttonStyle" v-on:click="articleDownload()" :disabled="loading" style="margin-top: 20px;">
          Download Csv
        </b-button>
      </b-col>
      <b-col class="col-lg-4" style="text-align: center;">
        <b-form-file class="btn" 
                     v-model="file"
                     :state="Boolean(file)"
                     placeholder="Kies of sleep hier een bestand..."
                     drop-placeholder="Sleep hier een bestand..."
                     accept=".xlsm, .csv"
                     style="width: 60%; background-color: transparent; font-size: medium; color: black; margin-left: 17%; margin-right: 20%">
        </b-form-file>
        <b-button class="btn buttonStyle"  v-on:click="articleUpload()" :disabled="loading" style="margin-top: 10px;">
          Upload Csv
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'

  export default {
    name: 'DownloadUpload',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        file: null,
        title: 'Download/Upload',
        loading: false,
      }
    },
    created: function () {
      this.$api.get('login/isloggedon')
        .catch((error) => {
          this.handleHttpError(error, 'Je bent niet ingelogd')
        })
        .finally(() => {
          this.loading = false
        })
    },
    methods: {
      articleDownload() {
        this.$api({
          method: 'get',
          url: 'article/articletranslations',
          responseType: 'blob'
        })
          .then((res) => {
            var translationsFile = window.URL.createObjectURL(new Blob([res.data]));

            var docUrl = document.createElement('a');
            docUrl.href = translationsFile;
            docUrl.setAttribute('download', 'Translations.csv');
            document.body.appendChild(docUrl);
            docUrl.click();
          })
          .catch((error) => {
            this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de csv.')
          })
      },
      articleUpload() {
        if (this.file == null) {
          alert("Selecteer een bestand")
          return;
        }
        this.loading = true;
        const formData = new FormData();
        formData.append('file', this.file);
        const headers = { 'Content-Type': 'multipart/form-data' };

        this.$api.post('article/articletranslationsFile', formData, { headers })
          .then(() => {
            alert("Succesvol geupload")
          })
          .catch((error) => {
            this.handleHttpError(error, 'Er ging iets fout bij het verwerken van het bestand.')
          })
          .finally(() => {
            this.loading = false
          })
      },
      parse() {
        // Always return a Promise
        return new Promise((resolve, reject) => {
          let content = '';
          const reader = new FileReader();
          // Wait till complete
          reader.onloadend = function (e) {
            content = e.target.result;
            const result = content.split(/\r\n|\n/);
            resolve(result);
          };
          // Make sure to handle error states
          reader.onerror = function (e) {
            reject(e);
          };
          reader.readAsText(this.file);
        });
      }

    }
  }
</script>
